"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.closeIconSpan = exports.closeIconCircle = exports.closeWrapper = exports.badgeContent = exports.badge = void 0;
exports.badge = {
    display: 'flex',
    margin: '0px',
    border: '1px solid #66e4ee',
    fontSize: '0.9rem',
    fontWeight: 'bold',
    padding: '0.9rem',
    color: '#004666',
    background: '#fff',
};
exports.badgeContent = {
    marginRight: '0px',
    float: 'left',
    width: 'calc(100% - 2rem)',
    display: 'table',
    height: '100%',
};
exports.closeWrapper = {
    marginRight: '0px',
    float: 'left',
    width: '2rem',
    height: '100%',
};
exports.closeIconCircle = {
    border: '1px solid #66e4ee',
    borderRadius: '50%',
    fontSize: '1rem',
    padding: ' 8%',
};
exports.closeIconSpan = {
    display: 'table-cell',
    verticalAlign: 'middle',
};
